import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";
// const URL = "https://devnode.foodonreels.com:3235/api/user/v1/master";
const URL = process.env.REACT_APP_MASTER_URL;
// ---------------------Blog-listing--------------------------
export const blogListApi = async (data) => {
  const endPoint =
    `blog/list` + "?" + new URLSearchParams({ ...data }).toString();

  return await axios.get(endPoint, setJwtToken());
};
// ------------------------Add BLog------------------
export const addBlogApi = async (data) => {
  const endPoint = `blog/add`;
  return await axios.post(endPoint, data, setMultiPartHeader());
};
// ------------------------Edit Blog------------------
export const editBlogApi = async (data) => {
  const endPoint = `blog/update`;
  return await axios.put(endPoint, data, setMultiPartHeader());
};
export const updateBlogStatus = async (data) => {
  const endPoint = `blog/status`;
  return await axios.put(endPoint, data, setJwtToken());
};
// ------------------------- remove Status------------
export const removeBlogApi = async (id) => {
  const endPoint = `blog/delete/${id}`;
  return await axios.delete(endPoint, setJwtToken());
};
// ------------------------- event detail------------
export const blogDetailApi = async (id) => {
  const endPoint = `blog/detail/${id}`;
  return await axios.get(endPoint, setJwtToken());
};

// --------------get-Product-List-Api------------
export const getProductListApi = async (id) => {
  // const endPoint = `${URL}user/v1/master/product_list`;
  const endPoint = `${URL}/product_list`;
  // `master/product_list`;

  return await axios.get(endPoint, setJwtToken());
};
